import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { shapes } from '@cimpress/react-components';

// TODO: Remove this once it has been moved into the React Component library.
class AsyncImage extends PureComponent {
  static propTypes = {
    src: PropTypes.string,
    alt: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
    timeoutMs: PropTypes.number
  };

  static defaultProps = {
    alt: '',
    width: 50,
    height: 50,
    timeoutMs: 5000
  };

  state = {
    imgLoaded: false,
    imgLoading: true,
    timedOut: false
  };

  componentDidMount() {
    if (this.props.src) {
      clearTimeout(this.timer);
      setTimeout(() => {
        if (this.unmounted) {
          return;
        }
        return this.setState({ timedOut: true });
      }, this.props.timeoutMs);
    } else {
      this.setState({ timedOut: true });
    }
  }

  componentDidUpdate(prevProps) {
    const { src } = this.props;

    if (src !== prevProps.src) {
      this.setState(
        {
          imgLoading: true,
          imgLoaded: false,
          timedOut: false
        },
        () =>
          setTimeout(() => {
            if (this.unmounted) {
              return;
            }
            return this.setState({ timedOut: true });
          }, this.props.timeoutMs)
      );
    }
  }

  componentWillUnmount() {
    this.unmounted = true;
    clearTimeout(this.timer);
  }

  onImgLoad = () => {
    this.setState({ imgLoading: true, imgLoaded: true });
  };

  render() {
    const { src, alt, width, height, timeoutMs, ...rest } = this.props;
    const { imgLoaded, imgLoading, timedOut } = this.state;

    const widthPx = `${width}px`;
    const heightPx = `${height}px`;

    const containerStyle = { width: widthPx, height: heightPx };
    const spinnerContainerStyle = {
      height: heightPx,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    };

    const spinnerSize = Math.min(width, height) / 2;

    return (
      <div className="async-image" style={containerStyle}>
        {imgLoading && !imgLoaded && !timedOut ? (
          <div className="async-image__spinner" style={spinnerContainerStyle}>
            <shapes.Spinner size={spinnerSize} style={{ height: `${spinnerSize}px` }} />
          </div>
        ) : null}
        <img src={src || ''} alt={alt} width={widthPx} height={heightPx} onLoad={this.onImgLoad} {...rest} />
      </div>
    );
  }
}

export default AsyncImage;
